import ApiService from "@/core/services/api.service";

// action types
export const FETCH_COMPANY_DESTINATIONS = "fetchCompanyDestinations";

// mutation types
export const SET_COMPANY_DESTINATIONS = "setCompanyDestinations";
export const SET_COMPANY_DESTINATIONS_PAGINATION =
  "setCompanyDestinationsPagination";

const state = {
  companyDestinations: [],
  companyDestinationsPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  }
};

const getters = {
  companyDestinations(state) {
    return state.companyDestinations;
  },
  companyDestinationsPagination(state) {
    return state.companyDestinationsPagination;
  }
};

const actions = {
  [FETCH_COMPANY_DESTINATIONS](context, name = null) {
    let params = {
      page: context.state.companyDestinationsPagination.currentPage
    };
    if (name) {
      params.name = name;
    }
    return new Promise((resolve, reject) => {
      ApiService.query("company/destinations", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_COMPANY_DESTINATIONS, data.data);
          context.commit(SET_COMPANY_DESTINATIONS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_COMPANY_DESTINATIONS](state, companyDestinations) {
    state.companyDestinations = companyDestinations;
  },
  [SET_COMPANY_DESTINATIONS_PAGINATION](state, data) {
    state.companyDestinationsPagination = data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
